import styled from "@emotion/styled";
import { InputLabel } from "@mui/material";

export const ReplacementReasonAndProblemInputLabel = styled(InputLabel)(({ theme }) => ({
	color: theme.project.colors.fontColors.secondary
}));

export const ErrorTextContainer = styled.div({
	alignItems: "center",
	display: "flex",
	gap: 4,
	marginTop: 4,
	p: {
		fontSize: "0.875rem",
		fontWeight: 500,
		lineHeight: "143%",
		margin: 0
	}
});

export const FileErrorTextContainer = styled(ErrorTextContainer)(({ theme }) => ({
	color: theme.project.colors.fontColors.error,
	p: {
		color: "inherit"
	}
}));

export const ReplacementProblemDropdownOption = styled.div({
	display: "flex",
	flexDirection: "column",
	textWrap: "initial"
});

export const ReplacementReasonUploadFiles = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "10px",
	color: theme.project.colors.fontColors.main
}));

export const SelectThreeImagesText = styled.p(({ theme }) => ({
	...theme.project.typography.body.body1,
	margin: 0
}));

export const ImageUploadModalInfoText = styled.p(({ theme }) => ({
	fontSize: "12px",
	color: theme.project.colors.fontColors.secondary,
	margin: 0,
	"& span": {
		fontWeight: 500
	}
}));
export const ImageUploadModalInfoContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "8px"
});

export const ImageUploadViewContainer = styled.div({
	display: "block",
	flexDirection: "column",
	justifyContent: "space-between",
	minWidth: 0,
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis",
	"& p": {
		margin: "1rem 0 0.25rem 0",
		minWidth: 0
	},
	"& div": {
		wordBreak: "break-word"
	}
});

export const SelectReplacementReasonAndProblemDropdownsContainer = styled.div({
	flexWrap: "nowrap",
	display: "flex",
	gap: "16px",
	flexDirection: "column",
	width: "100%",
	boxSizing: "border-box"
});
